// // 3DScatterPlot.js
// import React from 'react';
// import Plot from 'react-plotly.js';

// const Scatter3DPlot = ({ data }) => {
//   const plotData = [
//     {
//       x: data.map(item => item.criticality),
//       y: data.map(item => item.vulnerability),
//       z: data.map(item => item.impact),
//       mode: 'markers',
//       marker: { size: 5 },
//       type: 'scatter3d'
//     }
//   ];

//   const layout = {
//     title: '3D Scatter Plot',
//     scene: {
//       xaxis: { title: 'Asset Criticality' },
//       yaxis: { title: 'Asset Vulnerability' },
//       zaxis: { title: 'Business Impact' }
//     }
//   };

//   return (
//     <Plot
//       data={plotData}
//       layout={layout}
//       style={{ width: '100%', height: '500px' }}
//     />
//   );
// };

// export default Scatter3DPlot;

// 3DScatterPlot.js
import React from 'react';
import Plot from 'react-plotly.js';

const Scatter3DPlot = ({ data }) => {
  const plotData = [
    {
      x: data.map(item => item.criticality),
      y: data.map(item => item.vulnerability),
      z: data.map(item => item.impact),
      mode: 'markers',
      marker: { size: 5, color: '#422AFB' }, // Customize marker color
      type: 'scatter3d'
    }
  ];

  const layout = {
    title: 'AIVRM Triad',
    scene: {
      xaxis: { title: 'Asset Criticality', showspikes: false, showline: true, color: '#8F9BBA' },
      yaxis: { title: 'Asset Vulnerability', showspikes: false, showline: true, color: '#8F9BBA' },
      zaxis: { title: 'Business Impact', showspikes: false, showline: true, color: '#8F9BBA' },
      // bgcolor: 'rgba(0,0,0,0)', // Make background transparent
    },
    // paper_bgcolor: 'rgba(0,0,0,0)', // Make the plot's paper background transparent
  };

  return (
    <Plot
      data={plotData}
      layout={layout}
      style={{ width: '100%', height: '700px' }}
    />
  );
};

export default Scatter3DPlot;
